// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Rmh0","modalForm":"UpgradeEpcsModal_modalForm__295Kw","modalFooter":"UpgradeEpcsModal_modalFooter__2dcdv"};